export const MCP_PAGE_TITLE = 'Cursor MCP';

export const MCP_PAGE_INTRO =
  'Connect Cursor to Arvid so agents can turn prompts into structured requirements, resolve questions and answers, and reach implementation-ready specs — without leaving your IDE.';

export const MCP_PAGE_CONTENT = `## What you can do

- Create structured requirements from a rough prompt
- List unresolved requirements and unanswered questions
- Run automated Q&A and summary generation until readiness ≥ 80%
- Fetch implementation summaries for Cursor agent handoff

## How it works

1. Click **Add to Cursor** above
2. Sign in to Arvid when Cursor opens your browser
3. Authorize Cursor to access your workspace
4. Call Arvid tools from Cursor chat or Plan mode
`;
